/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentFeature } from './DocumentFeature';
import {
	DocumentFeatureFromJSON,
	DocumentFeatureFromJSONTyped,
	DocumentFeatureToJSON,
	DocumentFeatureToJSONTyped,
} from './DocumentFeature';
import type { ValidationResult } from './ValidationResult';
import {
	ValidationResultFromJSON,
	ValidationResultFromJSONTyped,
	ValidationResultToJSON,
	ValidationResultToJSONTyped,
} from './ValidationResult';

/**
 *
 * @export
 * @interface CaseGetControlQueryResultValidationResult
 */
export interface CaseGetControlQueryResultValidationResult {
	/**
	 *
	 * @type {DocumentFeature}
	 * @memberof CaseGetControlQueryResultValidationResult
	 */
	feature?: DocumentFeature;
	/**
	 *
	 * @type {ValidationResult}
	 * @memberof CaseGetControlQueryResultValidationResult
	 */
	validationResult?: ValidationResult;
	/**
	 *
	 * @type {string}
	 * @memberof CaseGetControlQueryResultValidationResult
	 */
	title?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof CaseGetControlQueryResultValidationResult
	 */
	description?: string | null;
}

/**
 * Check if a given object implements the CaseGetControlQueryResultValidationResult interface.
 */
export function instanceOfCaseGetControlQueryResultValidationResult(
	value: object
): value is CaseGetControlQueryResultValidationResult {
	return true;
}

export function CaseGetControlQueryResultValidationResultFromJSON(
	json: any
): CaseGetControlQueryResultValidationResult {
	return CaseGetControlQueryResultValidationResultFromJSONTyped(json, false);
}

export function CaseGetControlQueryResultValidationResultFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CaseGetControlQueryResultValidationResult {
	if (json == null) {
		return json;
	}
	return {
		feature: json['feature'] == null ? undefined : DocumentFeatureFromJSON(json['feature']),
		validationResult:
			json['validationResult'] == null
				? undefined
				: ValidationResultFromJSON(json['validationResult']),
		title: json['title'] == null ? undefined : json['title'],
		description: json['description'] == null ? undefined : json['description'],
	};
}

export function CaseGetControlQueryResultValidationResultToJSON(
	json: any
): CaseGetControlQueryResultValidationResult {
	return CaseGetControlQueryResultValidationResultToJSONTyped(json, false);
}

export function CaseGetControlQueryResultValidationResultToJSONTyped(
	value?: CaseGetControlQueryResultValidationResult | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		feature: DocumentFeatureToJSON(value['feature']),
		validationResult: ValidationResultToJSON(value['validationResult']),
		title: value['title'],
		description: value['description'],
	};
}
